import ContentLoader from 'react-content-loader';
import { InfoCardLoader } from '../../Cards/InfoCard/InfoCardLoader';

export const SpeciesRegulationsLoader = ({
  uniqueLoaderKey = 'species-regulations-loader',
}: {
  uniqueLoaderKey?: string;
}) => {
  return (
    <>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4 md:grid-cols-3">
        <InfoCardLoader uniqueLoaderKey={`${uniqueLoaderKey}-info-card-1`} size="lg" />
        <InfoCardLoader uniqueLoaderKey={`${uniqueLoaderKey}-info-card-2`} size="lg" />
        <InfoCardLoader uniqueLoaderKey={`${uniqueLoaderKey}-info-card-3`} size="lg" />
        <InfoCardLoader uniqueLoaderKey={`${uniqueLoaderKey}-info-card-4`} size="lg" />
        <InfoCardLoader uniqueLoaderKey={`${uniqueLoaderKey}-info-card-5`} size="lg" />
      </div>
      <div className="mt-10 grid grid-cols-12 gap-4 sm:grid-cols-4 md:grid-cols-12">
        <ContentLoader
          uniqueKey={`${uniqueLoaderKey}-accordion-1`}
          width="100%"
          height="100%"
          backgroundColor="#e5e7eb"
          foregroundColor="#d1d5db"
          className="col-span-full h-14 w-full overflow-hidden rounded-md sm:col-span-3 md:col-span-full"
        >
          <rect x="0" y="0" rx="4" ry="4" width="100%" height="100%" />
        </ContentLoader>
        <ContentLoader
          uniqueKey={`${uniqueLoaderKey}-accordion-2`}
          width="100%"
          height="100%"
          backgroundColor="#e5e7eb"
          foregroundColor="#d1d5db"
          className="col-span-full h-14 w-full overflow-hidden rounded-md sm:col-span-3 md:col-span-full"
        >
          <rect x="0" y="0" rx="4" ry="4" width="100%" height="100%" />
        </ContentLoader>
        <ContentLoader
          uniqueKey={`${uniqueLoaderKey}-accordion-3`}
          width="100%"
          height="100%"
          backgroundColor="#e5e7eb"
          foregroundColor="#d1d5db"
          className="col-span-full h-14 w-full overflow-hidden rounded-md sm:col-span-3 md:col-span-full"
        >
          <rect x="0" y="0" rx="4" ry="4" width="100%" height="100%" />
        </ContentLoader>
      </div>
    </>
  );
};
